import React, { useEffect, useMemo, useState } from "react";
import "../../../../styles/StayUptoDateCSS/StayUpToDateControls.css";
import { updateComponent } from "../../../../Utils/SupabaseServices/StayUpToDateDatabase";
import { supabase } from "../../../../config/supabaseClient";
import { StaticVariables } from "../../../../Utils/StaticVariables";
import { useLoadQueryFeed } from "./useLoadQueryFeed";
import RemovedContentTable from "../../../../components/EditModalComponents.tsx/RemovedContentTable";
import { getPostTitle } from "../../../../Utils/HelperFunction/HelperFunction";

import CarouselControlWrapper from "../../../../components/CarouselControls/CarouselControlWrapper";
import LoadingPost from "../../../../components/skeleton/Views/LoadingPost";
import { DuplicateNameError, updateNameValues } from "../../../../Utils/StayUpToDate/RenderComponent";
import CarouselFilterControl from "../../../../components/CarouselControls/CarouselFilterControl";
import EditableText from "../../../../components/EditModalComponents.tsx/EditableText";
import PostCardComponent from "../../../../components/EditModalComponents.tsx/PostCardComponent";
import { validateTitleForEdit } from "../../../../Utils/helpers/carouselHelper";
import { Modal } from "antd";
import Skeleton from "react-loading-skeleton";
import NoPostMsg from "../../../../components/NoPostMsg/NoPostMsg";
import '../../../../index.css'
import { useQueryClient } from "react-query";

const EditQueryBasedCarousel = (props: any) => {
  const {
    username,
    user_id,
    isQueryLinksEditModalOpen,
    setIsQueryLinksEditModalOpen,
    type,
    component,
    refetchDashboard,
    initial,
    setInitial,
    from,
  } = props;

  const queryClient = useQueryClient();
  const [name, setName] = useState(component.name || ""); // const [details, setDetails] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true); // State to manage button disable state
  const [postIds, setPostIds] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [defaultQuery, setDefaultQuery] = useState("");
  const [removePostIds, setRemovePostIds] = useState<any>("");
  const [isChange, setIsChange] = useState(false);
  const [order, setOrder] = useState("DESC");
  const [shape, setShape] = useState("rect");
  const [activeFilter, setActiveFilter] = useState("both");
  const [isSoundOn, setIsSoundOn] = useState();
  const [isActionLoading, setIsActionLoading] = useState(false);

  const [edit, setEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [editIndex, setEditIndex] = useState("");
  useEffect(() => {
    setPostIds(component?.post_ids);
    setName(component?.name);
    setDefaultQuery(component?.query);
    setRemovePostIds(component?.removed_postids);
    setOrder(component?.content_order);
    setShape(component?.content_shape);
    setIsSoundOn(component?.content_sound);
    setActiveFilter(component?.shoppable_content_filter || "both");
  }, [component]);
  const handleInputChange = (value: string, setter: Function) => {
    setter(value); // Set the input value
    setIsButtonDisabled(!value); // Disable button if either name or details is empty
  };

  const showSocials =
    component.type === "query-content"
      ? StaticVariables().CONTENT_PLATFORMS
      : StaticVariables().PLATFORMS;

  const isShopLinks = component.type === "query-content" ? false : true;

  const handleOk = async () => {
    // Validate the new title
    const validation = validateTitleForEdit(name, component);
    if (!validation.isValid) {
      setErrorMsg(validation.error || "Invalid title");
      return;
    }

    setConfirmLoading(true);
    const res = await updateComponent(
      name,
      component,
      username,
      user_id,
      defaultQuery,
      component?.type,
      "",
      "",

      removePostIds,
      order,
      shape,
      isSoundOn,
      activeFilter,
      from
    );

    if (res === "true") {
      // props.refetch();
      refetchDashboard();
      props.setIsQueryLinksEditModalOpen(false);
      props.setSelectedComponent("");
      setConfirmLoading(false);

      setName("");
      setPostIds("");
      setErrorMsg("");
      setDefaultQuery("");
      setRemovePostIds("");
      setIsChange(false);
      setEdit(false);
      setEditIndex("");
    } else {
      setErrorMsg(DuplicateNameError());
      setConfirmLoading(false);
      setEdit(false);
      setEditIndex("");
    }
  };

  const handleCancel = () => {
    props.setIsQueryLinksEditModalOpen(false);
    props.setSelectedComponent("");
    refetchDashboard();
    setName("");
    setPostIds("");
    setErrorMsg("");
    setDefaultQuery("");
    setRemovePostIds("");
    setEdit(false);
    setEditIndex("");
    setActiveFilter("both");
  };

  async function handleRemovedPostIds(post_ids: any, type: any) {
    if (type === "minus") {
      setRemovePostIds((prev: any) => {
        const idsArray = prev?.split(",").filter(Boolean);
        idsArray.push(post_ids);

        return idsArray.join(",");
      });
    } else if (type === "add") {
      setRemovePostIds((prev: any) => {
        const idsArray = prev.split(",").filter(Boolean);
        const filteredArray = idsArray.filter((elem: any) => elem !== post_ids);
        return filteredArray.join(",");
      });
    }
  }
  return (
    <>
      <Modal
        open={isQueryLinksEditModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Update"
        confirmLoading={confirmLoading}
        okButtonProps={{ disabled: !name }}
        data-testid="edit-query-carousel"
        focusTriggerAfterClose={false}
        getContainer={false}
        style={{ top: "15px" }}
      >
        <div className="mt-1">
          <h5 className="editTitle fontsize-16">Editing {name}</h5>

          {errorMsg && <p className="errorMsg text-center">{errorMsg}</p>}
          {component?.query && component?.query !== "" && (
            <p className="text-center" style={{ fontSize: "var(--font-tier-3) !important" }}>
              Content shown based on "{component?.query}"
            </p>
          )}
          <label className="bold-label fontsize-12">Preview</label>
          <AddedContentTable
            post_ids={component?.post_ids?.split(",")}
            username={username}
            user_id={user_id}
            setPostIds={setPostIds}
            handleRemovedPostIds={handleRemovedPostIds}
            componentName={name}
            refetchDashboard={refetchDashboard}
            removePostIds={removePostIds}
            setRemovePostIds={setRemovePostIds}
            type={component?.type}
            displayName={component?.display_name}
            query={component?.query}
            setIsChange={setIsChange}
            isChange={isChange}
            component={component}
            order={order}
            shape={shape}
            isSoundOn={isSoundOn}
            edit={edit}
            setEdit={setEdit}
            editIndex={editIndex}
            setEditIndex={setEditIndex}
            isActionLoading={isActionLoading}
            setIsActionLoading={setIsActionLoading}
            activeFilter={activeFilter.toLowerCase()}
            showSocials={showSocials}
            isShopLinks={isShopLinks}
            name={name}
            setName={setName}
            errorMsg={errorMsg}
            setErrorMsg={setErrorMsg}
          />
          <label className="bold-label fontsize-12">Settings</label>
          <div className="carousel-controls-wrapper">
            <div className="addedContent">
              {isShopLinks && (
                <CarouselFilterControl
                  type={type}
                  setActiveFilter={setActiveFilter}
                  activeFilter={activeFilter.toLowerCase()}
                  setCurrentPage={() => { }}
                  username={username}
                  user_id={user_id}
                  query={defaultQuery}
                  POSTS_PER_PAGE={10}
                  showSocials={showSocials}
                  isShopLinks={isShopLinks}
                  order={order}
                  componentName={name}
                />
              )}

              <CarouselControlWrapper
                showShape={true}
                showSound={true}
                showFilter={false}
                showOrder={true}
                shape={shape}
                setShape={setShape}
                isSoundOn={isSoundOn}
                setIsSoundOn={setIsSoundOn}
                type={type}
                order={order}
                setOrder={setOrder}
              />
            </div>
          </div>
          <RemovedContentTable
            post_ids={component?.post_ids?.split(",")}
            username={username}
            user_id={user_id}
            setPostIds={setPostIds}
            handleRemovedPostIds={handleRemovedPostIds}
            componentName={name}
            refetchDashboard={refetchDashboard}
            removePostIds={removePostIds}
            setRemovePostIds={setRemovePostIds}
            type={component?.type}
            displayName={component?.display_name}
            query={component?.query}
            edit={edit}
            setEdit={setEdit}
            editIndex={editIndex}
            setEditIndex={setEditIndex}
            isActionLoading={isActionLoading}
            setIsActionLoading={setIsActionLoading}
          />
        </div>
      </Modal>
    </>
  );
};
const AddedContentTable = (props: any) => {
  const {
    username,
    user_id,
    post_ids,
    componentName,
    refetchDashboard,
    setRemovePostIds,
    type,
    displayName,
    removePostIds,
    query,
    setIsChange,
    isChange,
    component,
    order,
    shape,
    isSoundOn,
    // edit, editIndex, setEdit, setEditIndex
    edit,
    editIndex,
    setEdit,
    setEditIndex,
    isActionLoading,
    setIsActionLoading,
    activeFilter,
    showSocials,
    isShopLinks,
    name,
    setName,
    errorMsg,
    setErrorMsg,
  } = props;

  const queryClient = useQueryClient();
  const [postIds, setPostIds] = useState(post_ids);
  const [deletePostIds, setDeletePostIds] = useState(removePostIds);
  const [localPosts, setLocalPosts] = useState<any[]>([]);

  useEffect(() => {
    setDeletePostIds(removePostIds);
  }, [removePostIds]);

  const contentOrder = StaticVariables().DEFAULT_CONTENT_ORDER;

  const {
    isLoading,
    data,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
  }: any = useLoadQueryFeed(
    username,
    user_id,
    query,
    showSocials,
    contentOrder,
    isShopLinks,
    deletePostIds,
    componentName,
    order
  );

  useEffect(() => {
    refetch();
  }, [activeFilter]);

  useEffect(() => {
    const showSocial =
      activeFilter === "both"
        ? StaticVariables().PLATFORMS
        : activeFilter === "content"
          ? StaticVariables().CONTENT_PLATFORMS
          : activeFilter === "products"
            ? StaticVariables().PRODUCT_PLATFORMS
            : StaticVariables().PLATFORMS;

    if (activeFilter) {
      const filteredArray = (data || [])
        .filter((element: any) => element !== undefined)
        .filter((item: any) => showSocial.includes(item.platform));
      setLocalPosts(filteredArray);
    } else if (data) {
      const filtered = data
        .filter((element: any) => element !== undefined)
        .filter((obj: any) => {
          const deleteIdsArray = deletePostIds?.split(",") || [];
          return !deleteIdsArray.includes(obj.post_id);
        });
      setLocalPosts(filtered);
    }
  }, [data, deletePostIds, activeFilter]);

  const onMinus = async (post_id: string) => {
    setLocalPosts((prev) => prev.filter((post) => post.post_id !== post_id));

    setDeletePostIds((prev: any) => {
      const idsArray = prev.split(",").filter(Boolean);
      idsArray.push(post_id);
      return idsArray.join(",");
    });

    await props.handleRemovedPostIds(post_id, "minus");
    refetch();
  };
  const [value, setValue] = useState<string>();
  // const [edit, setEdit] = useState(false);
  // const [editIndex, setEditIndex] = useState("");

  const handleDone = async (post_id: string, newValue: string) => {
    const dashboardQueryKey = [
      "paginatedQueryFeedMaxCount",
      component.query,
      user_id,
      component.removed_postids,
      component.name,
      component.content_order,
    ];

    // Optimistically update the local state for the modal
    setLocalPosts((prevPosts) =>
      prevPosts.map((post) => {
        if (post.post_id === post_id) {
          if (type === "content" || type === "query-content") {
            return { ...post, content_title: newValue };
          } else {
            return { ...post, shop_title: newValue, product_name: newValue };
          }
        }
        return post;
      })
    );

    try {
      await updateNameValues(username, type, post_id, user_id, newValue);
      setIsChange(true);
    } catch (error) {
      console.error("Error updating post title:", error);
      // If the update fails, we don't need to revert the local state
      // because the query invalidation will refetch the correct data.
    } finally {
      // Invalidate the dashboard query to trigger a refetch
      queryClient.invalidateQueries(dashboardQueryKey);
      setEdit(false);
      setEditIndex("");
      // refetch() is for the modal's own data, which we already updated locally.
      // We can keep it for consistency, or remove it if it causes a flicker.
      refetch();
      // refetchDashboard is likely redundant now but we'll keep it for safety.
      refetchDashboard();
    }
  };

  const SkeletonStatBox = () => {
    return (
      <div className="skeleton-stat">
        <Skeleton className="skeleton-style" />
      </div>
    );
  };

  return (
    <>
      <div className="addedContent">
        <EditableText
          value={componentName}
          onSave={async (newValue: any) => {
            if (!newValue.trim()) {
              setErrorMsg("Title cannot be empty");
              // setName(newValue);
              return;
            }
            // Validate the new title
            const validation = validateTitleForEdit(newValue.trim(), component);
            if (!validation.isValid) {
              setErrorMsg(validation.error || "Invalid title");
              return;
            }
            setErrorMsg("");
            setIsActionLoading(true);
            setEditIndex("title");
            try {
              // Update the parent component's name state
              setName(newValue);
            } catch (error) {
              console.error("Error updating component title:", error);
            } finally {
              setIsActionLoading(false);
              setEditIndex("");
            }
          }}
          isLoading={isActionLoading && editIndex === "title"}
          className="addedContentTitle editable-heading"
          textClassName="addedContentTitle"
          textStyle={{ fontWeight: "bold", fontSize: "18px" }}
          placeholder="Enter Title"
          setErrorMsg={setErrorMsg}
        />
        <div className="added-content">
          {localPosts.length > 0 ? (
            localPosts.map((post: any, index: any) => (
              <React.Fragment key={post.post_id}>
                <div className="feed-tab-post-container added-post">
                  <PostCardComponent
                    post={post}
                    type={type}
                    isShopLinks={isShopLinks}
                    shape={shape}
                    isSoundOn={isSoundOn}
                    onMinus={onMinus}
                    from="added"
                    isPodcast={post?.platform == "podcast"}
                  />
                  <EditableText
                    value={getPostTitle(post, type)}
                    onSave={async (newValue: any) => {
                      setValue(newValue);
                      setIsActionLoading(true);
                      setEditIndex(index);
                      try {
                        await handleDone(post.post_id, newValue);
                      } catch (error) {
                        console.error("Error updating post title:", error);
                      } finally {
                        setIsActionLoading(false);
                        setEditIndex("");
                      }
                    }}
                    isLoading={isActionLoading && editIndex === index}
                    textStyle={{
                      textAlign:
                        post?.shop_title !== "" ||
                          post?.product_name !== "" ||
                          post?.content_title !== ""
                          ? "left"
                          : "center",
                    }}
                  />
                </div>
              </React.Fragment>
            ))
          ) : isLoading ? (
            <div className="skeleton-stat-box">
              {[...Array(3)].map((_, index) => (
                <SkeletonStatBox key={index} />
              ))}
            </div>
          ) : (
            <NoPostMsg message="No Content Added Yet" />
          )}
        </div>
      </div>
    </>
  );
};

export default EditQueryBasedCarousel;
